import React, { useEffect, useMemo } from "react";

import { Typography } from "antd";
import { TableViews } from "../../Tables/AntTables/AntTables";

import { Shift } from "../../../redux/apis/types";
import { useSelector } from "react-redux";
import { State } from "../../../redux/root-reducer";
import { isClient } from "../../../constants";
import { FormProvider } from "react-hook-form";
import { getShiftStatusColor } from "../Planning/planningUtils";

const NoteList = () => {
  const { planningDetails } = useSelector((state: State) => state.Planning);

  const noteShifts = useMemo(
    () => planningDetails?.shifts?.filter((item) => !!item.note),
    [planningDetails?.shifts]
  );

  const columns = [
    {
      title: "Agents",
      width: "30%",
      render: (text: string, record: Shift) => (
        <Typography.Text>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
            {record.agents.map((agent, index) => (
              <span key={agent.id + agent.id}>
                <span
                  style={{
                    color: getShiftStatusColor(agent.pivot.status),
                    fontWeight: "bold",
                    marginRight: 3,
                  }}
                >
                  {`[${index + 1}]`}
                </span>
                {agent.first_name + " " + agent.last_name} (
                {agent?.user?.phone_number})
                {index < record.agents.length - 1 && <span>, </span>}
              </span>
            ))}
          </div>
        </Typography.Text>
      ),
    },
    {
      title: "Note",
      render: (text: string, record: Shift) => (
        <Typography.Text>{record.note}</Typography.Text>
      ),
      hidden: isClient ? true : false,
    },
  ];

  return <TableViews.SimpleView columns={columns} dataSource={noteShifts} />;
};

export default NoteList;
